import React from 'react';
import loadable from '@loadable/component';

const AdditionalOptionsFilter = loadable(
  () =>
    import(
      /* webpackChunkName: "AdditionalOptionsFilter.loadable" */ 'app/shared/modules/MobileSRP/Header/FilterModules/AdditionalOptionsFilter/component'
    ),
);

class LoadableAdditionalOptionsFilter extends React.Component {
  render() {
    return <AdditionalOptionsFilter {...this.props} />;
  }
}

export default LoadableAdditionalOptionsFilter;
